import * as React from "react";
const SvgFiRrQueueAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-queue-alt_svg__a)">
      <path
        fill="#062147"
        d="M20.5 6h-2C16.57 6 15 7.57 15 9.5v4c0 1.391.822 2.585 2 3.149V23a1 1 0 0 0 2 0v-6h1v6a1 1 0 0 0 2 0v-6.351a3.5 3.5 0 0 0 2-3.149v-4C24 7.57 22.43 6 20.5 6m1.5 7.5c0 .827-.673 1.5-1.5 1.5h-2c-.827 0-1.5-.673-1.5-1.5v-4c0-.827.673-1.5 1.5-1.5h2c.827 0 1.5.673 1.5 1.5zm-8.02-6.649a1 1 0 0 1-.781 1.179A1.504 1.504 0 0 0 12 9.5v4c0 .477.219.914.601 1.2.251.189.399.485.399.8V22a1 1 0 0 1-2 0v-6.051a3.52 3.52 0 0 1-1-2.449v-4a3.51 3.51 0 0 1 2.801-3.43.997.997 0 0 1 1.179.781m-5 0a1 1 0 0 1-.781 1.179A1.504 1.504 0 0 0 7 9.5v3c0 .477.219.914.601 1.2.251.189.399.485.399.8V20a1 1 0 0 1-2 0v-5.051A3.52 3.52 0 0 1 5 12.5v-3a3.51 3.51 0 0 1 2.801-3.43.997.997 0 0 1 1.179.781m-5 0a1 1 0 0 1-.781 1.179A1.504 1.504 0 0 0 2 9.5v2c0 .477.219.914.601 1.2.251.189.399.485.399.8V18a1 1 0 0 1-2 0v-4.051A3.52 3.52 0 0 1 0 11.5v-2a3.51 3.51 0 0 1 2.801-3.43.996.996 0 0 1 1.179.781M17 2.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m-1.385 2.227A2.5 2.5 0 0 1 14.5 5a2.5 2.5 0 1 1 0-5c.402 0 .777.104 1.114.273A4.44 4.44 0 0 0 15 2.5c0 .814.234 1.568.615 2.227m-5 0A2.5 2.5 0 0 1 9.5 5a2.5 2.5 0 1 1 0-5c.402 0 .777.104 1.114.273A4.44 4.44 0 0 0 10 2.5c0 .814.234 1.568.615 2.227m-5 0A2.5 2.5 0 0 1 4.5 5a2.5 2.5 0 1 1 0-5c.402 0 .777.104 1.114.273A4.44 4.44 0 0 0 5 2.5c0 .814.234 1.568.615 2.227"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-queue-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrQueueAlt;
